import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography, Tab } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import studentsImage from '../assets/racl_students.png';
import raclCampingImage from '../assets/racl_2014camping_1280.jpg';

export default function Home(){

      const [content1, setContent1] = useState('');
     const [content2, setContent2] = useState('');
    
      useEffect(() => {
        fetch('/documents/racl_policy_for_parents.html') // Path relative to public folder
          .then(response => response.text())
          .then(data => setContent1(data));
      }, []);


      useEffect(() => {
          fetch('/documents/racl_policy_for_students.html') // Path relative to public folder
            .then(response => response.text())
            .then(data => setContent2(data));
        }, []);

    return (

        <>
        <Box height={100} />

            <Grid container spacing={0} alignItems="center" justify="left">
                <Grid item xs={2} />
                <Grid item xs={8}>

                    <Card>
                    <CardHeader title='关于三角区中文学校'/>
                    <CardContent>
                        <Box textAlign={'center'}>
                            <img src={raclCampingImage} alt="Camping" style={{ maxWidth: '100%', height: 'auto' }} />
                        </Box>
                        <br />
                        <br />
                        <br />
                        <Box textAlign={'left'}>
                            <Typography>
                              三角区中文学校，Triangle Chinese Language School（TriCLS），前身为Raleigh Academy of Chinese Language（RACL），成立于1995年，是一家注册的501(c)(3)非营利教育机构。三十多年来，TriCLS始终服务于北卡罗来纳州研究三角园区（Research Triangle Park）及周边社区，为家庭提供高质量的中文教育，弘扬中华文化，并通过丰富多元的教育项目促进学生的全面发展。
                            </Typography>
                            <br />
                            <Typography>
                              我们的使命是传承和弘扬中华语言与文化，倡导终身学习，凝聚家庭与社区力量，培养兼具双语能力、文化素养和国际视野的未来公民。 我们致力于帮助学生在跨文化环境中建立文化自信，成长为富有责任感、勇于担当、积极服务社区的世界公民。
                            </Typography>
                              <br />
                            <Typography>
                               TriCLS开设从学前班（Pre-K）到高中的系统中文课程。作为学校践行公益教育使命的重要举措，我们为学前班（Pre-K）提供免学费中文课程（Tuition-Free），让更多家庭能够从孩子幼年时期开始接触中文和中华文化，享有优质的语言学习机会。学校同时保存学生学习成绩，为符合条件的学生申请北卡高中世界语言学分提供支持。
                            </Typography>
                              <br />
                            <Typography>
                              除中文课程外，TriCLS还开设数学、公众演讲与辩论（Public Speaking & Debate）、STEM、科学奥林匹克（Science Olympiad）、艺术、体育及中华文化等多元化拓展课程，致力于培养学生的批判性思维、创新能力、领导力、团队合作精神和沟通表达能力，帮助他们全面成长，发掘潜能。
                            </Typography>
                              <br />
                            <Typography>
                              作为一所扎根社区的非营利学校，TriCLS的发展离不开教师、家长、志愿者和社区伙伴的共同支持。我们相信，教育不仅发生在课堂中，更源于家庭、学校与社区的紧密合作。学校努力营造开放、包容、充满关爱的学习环境，让每一位学生都能建立学习自信、增强文化认同、培养诚信品格，并树立服务社会的责任意识。
                            </Typography>
                              <br />
                            <Typography>
                                通过将中文学习、文化传承、社区参与和领导力培养有机结合，TriCLS致力于培养新一代具有国际竞争力的双语人才，使他们既能珍视中华文化传统，又能积极融入多元社会，在未来的学习、事业和生活中发挥积极影响，为社区贡献力量。
                            </Typography>
                              <br />
                              <br />
                            <Typography>
                              学校的上课时间为每周六上午。语言班：9:15am-11:00am，课外活动班：11:10am-1:00pm。学校日程安排与Wake County公立学校系统配套。语言班共有五百多学生注册，课外活动班约有三百多名学生。三角区中文学校热情欢迎三角地区的华裔子女及中文爱好者入学及光临。
                            </Typography>
                              <br />
                            <Typography>
                              三角区中文学校的校址位于 Apex Middle School:
                              400 E Moore St, Apex, NC 27502
                            </Typography>
                              <br />
                            <Typography>
                              邮政信箱为:
                              Triangle Chinese Language School
                              P O Box 50375
                              Raleigh, NC 27650-6375
                            </Typography>
                              <br />
                              <br />
                              <br />

                            <Typography>
                              Triangle Chinese Language School (TriCLS), formerly known as Raleigh Academy of Chinese Language (RACL), is a 501(c)(3) nonprofit educational organization founded in 1995. For more than 30 years, TriCLS has served families throughout North Carolina's Research Triangle Park by providing high-quality Chinese language education, promoting Chinese culture, and fostering academic excellence through innovative educational programs.
                            </Typography>
                            <br />
                            <Typography>
                              Our mission is to preserve and promote the Chinese language and cultural heritage, inspire lifelong learning, strengthen connections among families and communities, and prepare students to become confident bilingual communicators, culturally grounded individuals, and responsible global citizens.
                            </Typography>
                              <br />
                            <Typography>
                              TriCLS offers a comprehensive Chinese language curriculum from Pre-K through high school. As part of our commitment to making Chinese language education accessible to more families, our Pre-K Chinese program is tuition-free, providing young learners with an engaging introduction to the Chinese language and culture. Student academic records are maintained to support North Carolina high school world language credit when applicable.
                            </Typography>
                              <br />
                            <Typography>
                              In addition to language instruction, TriCLS provides a broad range of enrichment programs—including mathematics, public speaking and debate, STEM, Science Olympiad, arts, sports, and cultural activities—that cultivate critical thinking, creativity, leadership, collaboration, and effective communication.
                            </Typography>
                              <br />
                            <Typography>
                              As a community-based nonprofit organization, TriCLS is built upon the dedication of our teachers, volunteers, parents, and community partners. We believe education extends beyond the classroom and seek to create a welcoming, inclusive environment where students develop academic confidence, cultural identity, integrity, and a lifelong commitment to serving others.
                            </Typography>
                              <br />
                            <Typography>
                              By connecting language learning with cultural appreciation, community engagement, and leadership development, TriCLS strives to empower the next generation to embrace their heritage, contribute meaningfully to their communities, and succeed in an increasingly interconnected world.
                            </Typography>
                              <br />                              
                            <Typography>
                              School Address:  Apex Middle School, 400 E Moore St, Apex, NC 27502
                            </Typography>
                              <br />
                            <Typography>
                              School Mailing Address: Triangle Chinese Language School, PO Box 50375, Raleigh, NC 27650-6375
                            </Typography>
                        </Box>


                        </CardContent>
                    </Card>

                    <Card>
                        <CardHeader title='家长守则'/>
                        <CardContent>
                            <Box textAlign={'left'}>
                                <div dangerouslySetInnerHTML={{ __html: content1 }} />
                            </Box>
                        </CardContent>
                    </Card>

                    <Card>
                        <CardHeader title='学生守则'/>
                        <CardContent>
                            <Box textAlign={'left'}>
                                <div dangerouslySetInnerHTML={{ __html: content2 }} />
                            </Box>
                        </CardContent>
                    </Card>        

                </Grid> 
                <Grid item xs={2} />
            </Grid>

                    <Box height={80} />
</>

    );
}